export default {
  REQUEST_TRANSMIT_PICKUP_SERVICE(state) {
    state.statusTransmitPickupService = "sending";
  },
  SUCCESS_REQUEST_TRANSMIT_PICKUP_SERVICE(state) {
    state.statusTransmitPickupService = "success";
  },
  FAILED_REQUEST_TRANSMIT_PICKUP_SERVICE(state) {
    state.statusTransmitPickupService = "failed";
  },
};
